import React from 'react';
import { M8RateDTO } from 'services/production/types';

import {
  RateChangeFormViolation,
  RateChangeFormValues,
} from 'types/rateChangeFormTypes';
import { createRateChangeFormValues } from 'utils/rateChangeFormUtils';

export const useRateChangeForm = () => {
  const [values, setValues] = React.useState<RateChangeFormValues>(
    createRateChangeFormValues
  );

  const [violations, setViolations] = React.useState<RateChangeFormViolation[]>(
    []
  );

  const setM8RateDTO = React.useCallback((nextValue: M8RateDTO) => {
    setValues((prev) => ({
      ...prev,
      m8RateDTO: nextValue,
    }));

    setViolations([]);
  }, []);

  const setNextDateOn = React.useCallback((nextValue: null | string) => {
    setValues((prev) => ({ ...prev, nextDateOn: nextValue }));

    setViolations([]);
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setM8RateDTO,
    setNextDateOn,
  };
};
